module.exports = __webpack_public_path__ + "static/media/path_title.ed85526e.svg";